import SessionService from "./session";

const axios = require("axios").default;

const tokenBearer = SessionService.isLogged()
  ? `Bearer ${SessionService.session().token}`
  : undefined;

const http = axios.create({
  baseURL: process.env.VUE_APP_SIGNALR_URL,
  timeout: 5 * 60 * 1000,
  timeoutErrorMessage: "No connection with resources",
  headers: {
    authorization: tokenBearer,
    common: {
      Accept: "application/json"
    }
  }
});

export default http;
